@use "@fukuri-admins/ui/layout" as *;

.root {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
  }
}

.xs {
  width: 16px;
  height: 16px;

  circle {
    r: 7;
    stroke-width: 2;
  }
}

.sm {
  width: 20px;
  height: 20px;

  circle {
    r: 9;
    stroke-width: 2;
  }
}

.md {
  width: 24px;
  height: 24px;

  circle {
    r: 10.75;
    stroke-width: 2.5;
  }
}

.lg {
  width: 48px;
  height: 48px;

  circle {
    r: 22;
    stroke-width: 4;
  }
}

.track {
  opacity: 0.3;
  color: text('Disabled');
}

.arc {
  color: text('Disabled');
  transform-origin: center;
  animation: spin 0.8s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
